const recuperarSenhaInitialValues = {
    Email: '',
    ConfirmarEmail: '',
};
export default recuperarSenhaInitialValues;
